import {
  CButton,
  CCol,
  CContainer,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
} from "@coreui/react";
import { useState } from "react";
import { Spinner } from "react-bootstrap";
import { SUCCESS } from "../../utils/constants/tags";
import { errorAlert } from "../utils/messages";
import { deleteItem } from "../../api/generics";
import Operator from "../../models/operator";

interface OperatorDeleteModalProps {
  show: boolean;
  operator?: Operator;
  onCancel: () => void | Promise<void>;
  onSuccess: () => void | Promise<void>;
}

const OperatorDeleteModal: React.FC<OperatorDeleteModalProps> = ({
  show,
  operator,
  onCancel,
  onSuccess,
}) => {
  const [submitting, setSubmitting] = useState(false);

  const message = operator
    ? `Está seguro de que quiere eliminar el operador ${operator.name}`
    : "";

  const onDeleteClick = async () => {
    if (operator !== undefined) {
      setSubmitting(true);
      const operatorStatus = await deleteItem<Operator>(`/operators/${operator.id}/`, operator);

      if (operatorStatus.status !== SUCCESS) {
        let message = "Ha ocurrido un error!!";
        if (operatorStatus.detail !== undefined) {
          message = operatorStatus.detail;
        }
        errorAlert(message);
      } else {
        onSuccess();
      }

      setSubmitting(false);
    }
  };

  return (
    <CModal show={show} className="modal-danger" onClosed={onCancel} size="xl">
      <CModalHeader closeButton>
        <CModalTitle>Eliminar</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CContainer fluid>
          <CRow>
            <CCol sm="12">
              <h2>{message}</h2>
            </CCol>
          </CRow>
        </CContainer>
      </CModalBody>
      <CModalFooter>
        <CButton disabled={submitting} onClick={onDeleteClick} color="danger">
          {submitting ? (
            <Spinner
              animation="grow"
              style={{
                height: "17px",
                width: "17px",
                marginTop: "auto",
                marginBottom: "auto",
                marginRight: "10px",
              }}
            />
          ) : (
            <></>
          )}
          {submitting ? "Eliminando..." : "Eliminar"}
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

export default OperatorDeleteModal;
